import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-truncate" }
const _hoisted_2 = { class: "text-truncate" }
const _hoisted_3 = { class: "text-truncate" }
const _hoisted_4 = { class: "text-truncate" }
const _hoisted_5 = { class: "text-truncate" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_VZDeleteModal = _resolveComponent("VZDeleteModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.dataProp)
      ? (_openBlock(), _createBlock(_component_Datatable, {
          key: 0,
          "table-data": _ctx.tableDataLookupLangObj,
          "table-header": _ctx.tableHeaderLookupLang,
          total: _ctx.total,
          rowsPerPage: _ctx.rowsPerPage,
          page: _ctx.page,
          loading: _ctx.loading,
          showSearch: _ctx.showLookupLangSearch,
          defaultFilter: _ctx.defaultFilterLookupLang,
          addButtonText: `${_ctx.t('pages.lookup.addLanguage')}`,
          tableFilter: _ctx.tableFilterLookupLang,
          bulkDelete: _ctx.bulkDeleteLookupLang,
          tableForm: _ctx.formDataLookupLang,
          viewName: "lookupsLang",
          onFormSubmit: _ctx.submitLookupLang,
          onQueryUpdate: _ctx.syncQuery,
          permissions: _ctx.permissionModel,
          ref: "tableLookupLang"
        }, {
          "cell-baseText": _withCtx(({ row: lookup }) => [
            _createElementVNode("span", _hoisted_1, _toDisplayString(lookup.baseText), 1)
          ]),
          "cell-lang": _withCtx(({ row: lookup }) => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(lookup.lang), 1)
          ]),
          "cell-text": _withCtx(({ row: lookup }) => [
            _createElementVNode("span", _hoisted_3, _toDisplayString(lookup.text), 1)
          ]),
          "cell-createdDate": _withCtx(({ row: lookup }) => [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.format.DateTime(lookup.createdDate)), 1)
          ]),
          "cell-updateDate": _withCtx(({ row: lookup }) => [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.format.DateTime(lookup.updateDate)), 1)
          ]),
          "cell-actions": _withCtx(({ row: lookup }) => [
            (!lookup.lock && _ctx.hasPermission(_ctx.permissionModel.update))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  onClick: _withModifiers(($event: any) => (_ctx.editLookupLang(lookup)), ["stop"]),
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#vz-add-edit-modal-lookupsLang",
                  class: "btn btn-icon btn-primary btn-circle btn-sm"
                }, _hoisted_8, 8, _hoisted_6))
              : _createCommentVNode("", true),
            (_ctx.hasPermission(_ctx.permissionModel.delete))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  onClick: _withModifiers(
          () => {
            _ctx.showDeleteDialog = true;
            _ctx.selectedForActionLookupLang = lookup;
          }
        , ["stop"]),
                  class: "btn btn-icon btn-danger btn-circle btn-sm ms-3"
                }, _hoisted_11, 8, _hoisted_9))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["table-data", "table-header", "total", "rowsPerPage", "page", "loading", "showSearch", "defaultFilter", "addButtonText", "tableFilter", "bulkDelete", "tableForm", "onFormSubmit", "onQueryUpdate", "permissions"]))
      : _createCommentVNode("", true),
    _createVNode(_component_VZDeleteModal, {
      viewName: "lookupsLang",
      pageName: "lookupsLang",
      showDialog: _ctx.showDeleteDialog,
      selectedForAction: [_ctx.selectedForActionLookupLang.webId],
      deleteText: `${_ctx.t('validation.sureToDelete')} ${
      _ctx.selectedForActionLookupLang.baseText
    }?`,
      onClose: _ctx.refreshListLookupLang
    }, null, 8, ["showDialog", "selectedForAction", "deleteText", "onClose"])
  ], 64))
}